import { render, staticRenderFns } from "./JobFormsPage.vue?vue&type=template&id=f22e2580&"
import script from "./JobFormsPage.vue?vue&type=script&lang=js&"
export * from "./JobFormsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports